<template>
  <unit-archived :unit = 'unit' v-if = 'showArchived'></unit-archived>
  <unit-current :unit = 'unit' v-else></unit-current>
</template>
<script>
import UnitArchived from './unit_archived.vue'
import UnitCurrent from './unit_current.vue'

export default {
  props: ['unit'],

  computed: {
    showArchived() {
      return this.$store.state.showArchived
    }
  },

  components: {
    UnitArchived,
    UnitCurrent
  }
}
</script>



// WEBPACK FOOTER //
// unit.vue?0bb668d8